import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import type { ReactNode } from 'react';
import { cn } from './cn';

export interface ModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
  className?: string;
  panelClassName?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

const sizes = {
  sm: 'max-w-md',
  md: 'max-w-lg',
  lg: 'max-w-2xl',
  xl: 'max-w-4xl',
};

export function Modal({
  open,
  onClose,
  title,
  children,
  className,
  panelClassName,
  size = 'md',
}: ModalProps) {
  return (
    <Dialog open={open} onClose={onClose} className={cn('relative z-50', className)}>
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-stitch-overlay/45 backdrop-blur-sm transition duration-stitch ease-stitch-out data-[closed]:opacity-0"
      />
      <div className="fixed inset-0 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4">
          <DialogPanel
            transition
            className={cn(
              'w-full rounded-stitch-2xl border border-stitch-border bg-stitch-surface p-6 shadow-stitch-modal transition duration-stitch ease-stitch-out',
              'data-[closed]:scale-[0.98] data-[closed]:opacity-0',
              sizes[size],
              panelClassName,
            )}
          >
            {title && (
              <DialogTitle className="mb-4 text-lg font-semibold text-stitch-fg">
                {title}
              </DialogTitle>
            )}
            {children}
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}
